<template>
  <div>
    <Navbar/>
    <main class="main-container">
      <router-view/>
    </main>
    <Feedback />
  </div>
</template>
<script>
import Navbar from '@/components/app/employee/Navbar'
import Footer from '@/components/app/employee/Footer'
export default {
  name: 'employee-layout',
  components: {
    Navbar,
    Footer,
    Feedback: () => import('@/components/employee/feedbackModal'),
  },
}
</script>
